module.exports = __webpack_public_path__ + "images/email_blue2f70ed277b4621bf363755cd09ffc991.svg";